import { RegisteringUser } from '@/entities/auth/registeringUser';

export const emptyRegisteringUser = (): RegisteringUser => ({
  firstName: '',
  lastName: '',
  email: '',
  contactPhoneNumber: '',
  contactPhoneCode: '',
  contactPhoneCountry: '',
  password: '',
  locale: 'en',
  payload: {},
});
